<div class="container mt-4">
  <div class="row">
    <div class="col horizontal-scrolling">
      @for (item of items(); track item) {
        <div
          class="menu-container"
          tabindex="0"
          (keydown.enter)="navigateToRoute(item)"
          (click)="navigateToRoute(item)"
          routerLinkActive="active-link">
          <div class="menu-content" style="margin-right: 10px">
            <!-- routing in its own app -->
            @if (item.routerLinkUrl) {
              <a
                class="menu-item"
                [routerLink]="item.routerLinkUrl"
                queryParamsHandling="merge"
                [attr.target]="item.openInNewTab ? '_blank' : null"
                ><span class="{{ item.faIcon }} menu-icon"></span>{{ item.label }}</a
              >
            } @else {
              <!-- external url redirect -->
              <a
                class="menu-item"
                [href]="item.linkUrl"
                queryParamsHandling="merge"
                [attr.target]="item.openInNewTab ? '_blank' : null"
                ><span class="{{ item.faIcon }} menu-icon"></span>{{ item.label }}</a
              >
            }
          </div>
          <div class="arrow-down"></div>
        </div>
      }
    </div>
  </div>
</div>
